import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/52181f66/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const DoDontRow = makeShortcode("DoDontRow");
const DoDont = makeShortcode("DoDont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Checkboxes are used when there are multiple items to select in a list. Users can select zero, one, or any number of items.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Overview</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Formatting</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Content</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Behaviors</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Related</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
      <AnchorLink mdxType="AnchorLink">References</AnchorLink>
    </AnchorLinks>
    <h2>{`Overview`}</h2>
    <p>{`Checkboxes are used for multiple choices, not for mutually exclusive choices. Each checkbox works independently from other checkboxes in the list, therefore checking an additional box does not affect any other selections.`}</p>
    <h3>{`When to use`}</h3>
    <h4>{`Forms`}</h4>
    <p>{`Can be used in forms on a full page, in modals, or on side panels.`}</p>
    <h4>{`Filtering and batch action`}</h4>
    <p>{`Used to filter data either on a page, in a menu, or within a component. Checkboxes are found in `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/data-table/code"
      }}>{`Data table`}</a>{` for batch editing purposes.`}</p>
    <h4>{`Terms and conditions`}</h4>
    <p>{`Turning the checkbox input on or off can indicate whether you agree to the terms.`}</p>
    <h4>{`Lists with sub-selections`}</h4>
    <p>{`Used when there is a parent and child relationship. You can use a parent checkbox to make a bulk selection of all list items. Unchecking the parent deselects all of the list items. Alternatively, you can select children individually when the parent is not selected, which is where the indeterminate state comes in to play.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.29605263157895%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABaklEQVQ4y62T2a6CQAxA+VJDMGh89PsMQuJH+OCbK4jgCrj35jTpBO/NfZOkmWmnPV1m8N7vt3zrg+WxWa1WMh6PZTKZSJIkEsfxh3D2n3A+Go1ksVgoVIFRFInv+zIcDmUwGEgYhtLv950EQeCk2+06Qe/1etLpdJThgI/HQ/b7vdzvdye3202aptH1+Xw6qetazuezVFUl1+tVBR2GAxI4n88lyzI5Ho9yuVx0LctSgczm9XppUFEUstvtNAYbgk4iBwQwnU51lpvNRrOnaarBBrShc57nuVZmdqAkcEAOl8ulVng6nRTIejgcNBmBgLFTNUIHjIDxoMNwQJxpmZvCkUBstMFq7bInAcmYGzog8/+okOrIhDNBtEXLVNH+sOFLZe33Z7q7lNlsJtvtVrMBZI9Yy/aRyEZD5TbDP0BaBmAVtlsGiI89Fex2KYCI+QAStF6v3XOwt2fPgj0zRH7b7WJsNN63/+UfPILOOB+DhmsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full page filter list",
            "title": "Example of a full page filter list",
            "src": "/static/df711872915a06f7cb4c96982bc3479d/3cbba/checkbox-usage-1.png",
            "srcSet": ["/static/df711872915a06f7cb4c96982bc3479d/7fc1e/checkbox-usage-1.png 288w", "/static/df711872915a06f7cb4c96982bc3479d/a5df1/checkbox-usage-1.png 576w", "/static/df711872915a06f7cb4c96982bc3479d/3cbba/checkbox-usage-1.png 1152w", "/static/df711872915a06f7cb4c96982bc3479d/92c65/checkbox-usage-1.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">Example of a full page filter list</Caption>
    <h3>{`When not to use`}</h3>
    <p>{`If a user can select only one option from a list, radio buttons should be used instead of checkboxes. Checkboxes allow the user to select multiple items in a set whereas radio buttons allow the user to select only one option.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use radio buttons when only one item can be selected." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQ4y+2P3QrCIBiGt0EsVsRSUYZQ0eEuQFTw1Pu/pF4rhwdB+O0ggr3w8PrD96BNs+U/4pxbOlOer5J+2kspaTJrbY/10RizS3utdZtlVVLv/bNDCCes7zHGfXlf/ULOee4zY2wSQnBINLiCrlqqlMp9AAwM8pWJ9OVi6AYsGAvhuEaowAzSC9O3LyThtwGyLDVo371Akm75XR48Qxic0Do8WQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Do use radio buttons when only one item can be selected.",
            "title": "Do use radio buttons when only one item can be selected.",
            "src": "/static/a463b5a810f16dadb7b5cd8641f7560d/a5df1/checkbox-usage-2-do.png",
            "srcSet": ["/static/a463b5a810f16dadb7b5cd8641f7560d/7fc1e/checkbox-usage-2-do.png 288w", "/static/a463b5a810f16dadb7b5cd8641f7560d/a5df1/checkbox-usage-2-do.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </DoDont>
  <DoDont type="dont" caption="Don't use checkboxes when only one item can be selected." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAy0lEQVQ4y+2RXwuCMBTFW9iDSH8wnSs0CEFEBwoiqOCT0PM+Uh+9s9FCgh62HiLwwOHcuws/drfVatF/qO/7V2rPz7+CvvdhGKqklJrDuq5zUe/btnVkH8cx0SAj4DAMKsdx3KFOhRDOfG4Ek4qiSK9HgyA4wWDQFL7CGyvoUx68TZLEBdwH5GC1Mud8LTPLMpHn+V2CGWNnQC6wbwxsmobILMuSF0VxQ+kAeASEwZ7VytM0kU8zY5j+5bquSVVVan3cUIGs3nDRb/UAm2QbSjMZYMkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Don't use checkboxes when only one item can be selected.",
            "title": "Don't use checkboxes when only one item can be selected.",
            "src": "/static/fa3555cbf03ff8b17eeb7df1367e7fd4/a5df1/checkbox-usage-2-dont.png",
            "srcSet": ["/static/fa3555cbf03ff8b17eeb7df1367e7fd4/7fc1e/checkbox-usage-2-dont.png 288w", "/static/fa3555cbf03ff8b17eeb7df1367e7fd4/a5df1/checkbox-usage-2-dont.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </DoDont>
    </DoDontRow>
    <h2>{`Formatting`}</h2>
    <h3>{`Anatomy`}</h3>
    <p>{`The checkbox component is comprised of a checkbox label and a checkbox input. If there is a group of checkboxes, a group label can be added.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtUlEQVQoz52S4QqDIBSFe/832ktsBP7bj9hAooHkwjQz70kKYqsM68JFkXu/e9STYRVEtKy/+9TIokBPcxJt4EcDsr3DWEOK4q1CPxe37I02f8HZHrKuYYxJeorolS0XcGUA2Q6fqkIV0lo71xyojCpUjwL6XkApNQEX2OCnPK1w0AHgCJxzMMbwlRJ9gMpbDvMs/4af+hStNYQQaJpmAvjOXVO4tse6OfkNjyyy58lLwDPGHgHagmaAr8A0dwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Anatomy of a group of checkboxes.",
            "title": "Anatomy of a group of checkboxes.",
            "src": "/static/d8cda9a86ac9f88e50fefd0ca89ffe61/3cbba/checkbox-usage-3.png",
            "srcSet": ["/static/d8cda9a86ac9f88e50fefd0ca89ffe61/7fc1e/checkbox-usage-3.png 288w", "/static/d8cda9a86ac9f88e50fefd0ca89ffe61/a5df1/checkbox-usage-3.png 576w", "/static/d8cda9a86ac9f88e50fefd0ca89ffe61/3cbba/checkbox-usage-3.png 1152w", "/static/d8cda9a86ac9f88e50fefd0ca89ffe61/92c65/checkbox-usage-3.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Group label (optional):`}</strong>{` Communicates what needs to be selected below.`}</li>
      <li parentName="ol"><strong parentName="li">{`Checkbox input:`}</strong>{` A checkbox input indicating the appropriate state. By default it is unselected.`}</li>
      <li parentName="ol"><strong parentName="li">{`Checkbox label:`}</strong>{` Describes the information you want to select or unselect.`}</li>
    </ol>
    <h3>{`Alignment`}</h3>
    <p>{`Checkbox labels are positioned to the right of their inputs. If there is a checkbox grouping, they can be laid out vertically or horizontally depending on the use case and the structure of the UI. When possible, arrange the checkbox and radio button groups vertically for easier reading.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAAAwUlEQVQ4y61TiwqEIBDc//8+oS+IEjKyh2JRe4xw0HmWSg0M0ZbDLDMS3+A4juh7OD+DUmL7vvOyLOycS4plCVpruW1bbpqG13V97nCeZ+66zjt8ZeW6rlkIwdM08bZtaUF8vCIAIaystf5xeEXKTRnh5CDqEIfB2PzOnXeY+qGUlFPoElAYAp5KKZZS+qqge2Df976T31lYoz+H55sxDIMXQAeRrjGGq6ryM6SO2TiO0V7S01XDMxS7+CW8dPiW4AeB2KQ6q18k7wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Vertically stacked versus horizontal alignment",
            "title": "Vertically stacked versus horizontal alignment",
            "src": "/static/5ec5202b90484b0c9d95a3d6a3eaafa5/3cbba/checkbox-usage-4.png",
            "srcSet": ["/static/5ec5202b90484b0c9d95a3d6a3eaafa5/7fc1e/checkbox-usage-4.png 288w", "/static/5ec5202b90484b0c9d95a3d6a3eaafa5/a5df1/checkbox-usage-4.png 576w", "/static/5ec5202b90484b0c9d95a3d6a3eaafa5/3cbba/checkbox-usage-4.png 1152w", "/static/5ec5202b90484b0c9d95a3d6a3eaafa5/92c65/checkbox-usage-4.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">Vertically stacked versus horizontal alignment</Caption>
    <h3>{`Placement`}</h3>
    <p>{`The checkbox component is often used in forms. Forms can be placed on a full page, in a modal or in a side panel. A checkbox can also be used for agreeing to terms and conditions or to filter information.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.83552631578948%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAACUElEQVQ4y41Ta28SQRTtr/UXGD9AYiNNrDT6WRM08VHAAMurFJSXrUGxgVQSWYjaEAhFpIAsC2x32V2Ocwd2txpjO8nZuZm9c+beM2e2VqsVrhuUY5rmjfK2KDg5+YTXwSAEQUA4HEYoFEIkEkEgEECpVLI3iKKIbDaLYrGIfD7P40KhgFwuh1qtxnM4YX8wwlmrg3a7jcFggOFwyEGxJEl2dfF4HC6XCz6fD6lUCkfH7/Fqfx9utxtBVhAnpDKXugFNN2EYBt9MaxSrqgpN03hMI5PJwOPx4PAwjdlMZis6yh+O2doOYrHYhpB9VGUGTZF40iUjISJFUSDLMp+tCqmqe4zw2VMfMm/zeHOq4Hm4iB3PNpNIcFr+fDbDy/wE3f4Yi7nMiGaMfI2rhOl0Gl6vFw927+P2HRdubcdwd+8FHu7tQohGHUJFNTGSDd66rus2lsslb9dyAunZ7/dxwfQdj0eQhl2MLn6wtZ+YTCZrwpvYgXIsHa/L4xWe93qo1+toNpt/gGzS7XbtDb1NXqPR4BDFBstr4PvXL+h1O07LlUqF+y6ZTCKRSNggK1SrVZuwXC7D7/fbeQfJBIRYAo+eRJHOf3Rsc5MXQLBun9rXmd7qpYK5ouOdCLQGplPhYrHggk+nUxvz+Zzd+IxvsvShSyKQN+nSKE+a/GJ/NawMFVTb+pY3nrOsQmSSxGx03oe80KlGTkgkNFuw3rhumNDYQbDeMp1IpASqdrnU0Wl9w2P/EQ5OsSFccUJq91+gf//VcH06w8rR8Kqef8MavwHmC1gKoyzTngAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Placement of checkboxes in different UI scenarios.",
            "title": "Placement of checkboxes in different UI scenarios.",
            "src": "/static/67200208cbb6685bf9dcf6fb9b183b91/3cbba/checkbox-usage-5.png",
            "srcSet": ["/static/67200208cbb6685bf9dcf6fb9b183b91/7fc1e/checkbox-usage-5.png 288w", "/static/67200208cbb6685bf9dcf6fb9b183b91/a5df1/checkbox-usage-5.png 576w", "/static/67200208cbb6685bf9dcf6fb9b183b91/3cbba/checkbox-usage-5.png 1152w", "/static/67200208cbb6685bf9dcf6fb9b183b91/92c65/checkbox-usage-5.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <p>{`Checkboxes in a form should be placed at least 32px (`}<inlineCode parentName="p">{`layout-03`}</inlineCode>{`) below or before the next component. Spacing of 24px (`}<inlineCode parentName="p">{`layout-02`}</inlineCode>{`) or 16px (`}<inlineCode parentName="p">{`layout-01`}</inlineCode>{`) can also be used when space is more restricted or if the form is more complex.`}</p>
    <p>{`For more information on spacing in forms, see our `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/form/style"
      }}>{`form style guidance`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACbElEQVQ4y62Ty2sTURTGzyQWa6QPXWSjiI+FaxFxLegfoIVuRKioaatNbG1qXdRFNJaCrehWkGQV0F13QSxd5IEllWhiJy/yqElosdM4mcxkkpkk45nbNERMI7E98JvvMnfuxz33fgNw0KXX6xvaTPNcR/X4w3uil9JxeO1wUPN2u8budFIJRaFC5TIVliQqIsttCcsy8YjUFXpeWPbdaUSSdgZXH40TvWKegCGj8dxNg+GC2Wo9yyhKX6hY7I9KUjuOIb3RuhnRZWYLwDzef+bNwvFgsejBNpU1URSwjQK2y6PuBYdUkVXkkGpIWret+gBMo5rzc9bDnzOZoUSlYkzUandjkmSIyXI77iH3kUGEUg1jqiG3xZDtKooCG6mUPRkO+0WWdZdY1iu2x418QRyIVvVABfj4Yx1gbFh3+d3b3qQgpNBYERHpH6jfqJUShBzSpRqiAuTLeJDTk90nZp8d/ZRMjro3N5+v5HLTdK1m+l6tPlzbGxMyidxCSMuof91+d52uTmMTwCMjpau/OAmgxau6iMM+5EjHOdwN9cirBYBZi/b0gxHdvM02tejzjTmDwTuhUmkgXqtdx8AORFtzA+cGkWuxSoVq5NCzvQ0wNdFz6uVcv79QsH8TBH9AEDxfeX4lKIoeulJZpmW5FUuIF7EHRJHcMq3uEqOyGxsqFg4PR2jaivqUDgYtqXh8plgomEWeb8WkwHFP+Hz+Nq7VkNjwPEBBfewYahiGWUyn0xvpTCaOmshms6lfLLvOcdx6Pp//E45Lsiz7E+eXcC35U/A9NEK93zoIj9blcrmIer1eMv5fmr0OtH4Djj2l5TM1ZRYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The default state for checkboxes is unchecked.",
            "title": "The default state for checkboxes is unchecked.",
            "src": "/static/7673c3f4b3ccefcfc0a7ec58e42d66c5/3cbba/checkbox-usage-6.png",
            "srcSet": ["/static/7673c3f4b3ccefcfc0a7ec58e42d66c5/7fc1e/checkbox-usage-6.png 288w", "/static/7673c3f4b3ccefcfc0a7ec58e42d66c5/a5df1/checkbox-usage-6.png 576w", "/static/7673c3f4b3ccefcfc0a7ec58e42d66c5/3cbba/checkbox-usage-6.png 1152w", "/static/7673c3f4b3ccefcfc0a7ec58e42d66c5/92c65/checkbox-usage-6.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">Spacing between a checkbox and other components in a form</Caption>
    <p>{`For more information about spacing for the checkbox component itself, see the `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/checkbox/style#structure"
      }}>{`style tab`}</a>{`.`}</p>
    <h2>{`Content`}</h2>
    <h3>{`Main elements`}</h3>
    <h4>{`Group labels (optional)`}</h4>
    <ul>
      <li parentName="ul">{`If necessary, a heading can accompany a set of checkboxes to provide further context or clarity.`}</li>
      <li parentName="ul">{`A group label can either state the category of the grouping or describe what actions to take below.`}</li>
      <li parentName="ul">{`Use sentence case for group labels.`}</li>
      <li parentName="ul">{`In some cases, a group of checkboxes may be within a larger group of components that already have a group label. In this case, an additional group label for the checkbox component itself is not needed.`}</li>
      <li parentName="ul">{`Regardless of whether the label is visible in the interface, a group label is always needed in code, whether it’s for one checkbox or a group of them. See the `}<a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/checkbox/code"
        }}>{`checkbox code tab`}</a>{` for more information.`}</li>
    </ul>
    <h4>{`Checkbox labels`}</h4>
    <ul>
      <li parentName="ul">{`Always use clear and concise labels for checkboxes.`}</li>
      <li parentName="ul">{`Be explicit about the results that will follow if the checkbox is selected.`}</li>
      <li parentName="ul">{`Labels appear to the right of checkbox inputs.`}</li>
    </ul>
    <h3>{`Overflow content`}</h3>
    <ul>
      <li parentName="ul">{`We recommend checkbox labels being fewer than three words.`}</li>
      <li parentName="ul">{`If you are tight on space, consider rewording the label. Do not truncate checkbox label text with an ellipsis.`}</li>
      <li parentName="ul">{`Long labels may wrap to a second line, and this is preferable to truncation.`}</li>
      <li parentName="ul">{`Text should wrap beneath the checkbox so the control and label are top aligned.`}</li>
    </ul>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.16447368421053%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAABIklEQVQ4y62Tz2qEMBDGk90tWNbWFqu2CC3SIoJvoCD4qJ49+yCCJwX/4cGziFc7kVVicK2BDvyYoJMvE/INQkyoqrrke9B1h4Iu3hLUNO24KNMh3qqRZZm/OyIGvAAfwPst68CV7vyQICV6AmTgFXi7rZ93BcuyXFFVFWrbFsVxfPfQIAhQ3/dTLbv//wNUBZqiKJacZZmQpqmQ5/nq3x5EENPANTAI4a7rlhcehgGHYYijKMJJkuC6rjGIY3YvYbd7x3Eurus+jOPIdeUVnudN303TPFuWpdm2rRmG8QTeE8DQj7quT134vo+apvn7USRJmrIoimQtgtCXoiifYJFv4IdYiMuH81hBPgESMPuPcGGniXf05omZQVzdcY7mpugvzyi8K4toNlMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Text wrapping for checkboxes.",
            "title": "Text wrapping for checkboxes.",
            "src": "/static/5682b9645b17d54f2d46ea39e21e8311/3cbba/checkbox-usage-10.png",
            "srcSet": ["/static/5682b9645b17d54f2d46ea39e21e8311/7fc1e/checkbox-usage-10.png 288w", "/static/5682b9645b17d54f2d46ea39e21e8311/a5df1/checkbox-usage-10.png 576w", "/static/5682b9645b17d54f2d46ea39e21e8311/3cbba/checkbox-usage-10.png 1152w", "/static/5682b9645b17d54f2d46ea39e21e8311/92c65/checkbox-usage-10.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do let text wrap beneath the checkbox so the control and label are top aligned." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABmUlEQVQ4y+2Sy07CQBSGh3CJCC0k9H4RoYW2sbQC7tyTkhA3BrlE1PAY+gi+gkYx7vQd1MSNC1duNNFnwTMDRWiQRI07/uTLOXNmzsk/nSK01J+lX9UJ0/lPCc4hcu86vzalDbxZh9Z7j+TmzU4CDU8j+dd20nxopqy3fcp86VLWxwFlPDZpEp9atPncpnHUzmoM9CfJ0Atv5FAf1JFcM8hA9qSaMbZL5/mG68mHrq123YrScqpKx6mq/Yqt7JW21N6mC/Wy2i/bxftdVrv00ri3cNv4ujKD6Iljx7CPcrSco1GMZcIpHfayOGZQUmQiaZMJ0TlSQ5QSRyg691F8HQ+vR4mNQrws5DmJ1zhZkCAXAYmsRd7kJCHHKwIPa1NwsmHcAvuBR3HdSS6KYpTjOAvQgSKwBsiAAhQAFbCBDD4PcdalX4AYAlJAHKCBVYAar1eAxLiGz8Uwfv/M0KmB2JkBsIAGbIydOsA6UMZxnhn0XXE8NLTov/MdTRlZPDTYFGTuNb/5hjMHBUHAD4QkSSLRBwvXlvoffQL78V+Y/J++kQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Do let text wrap beneath the checkbox so the control and label are top aligned.",
            "title": "Do let text wrap beneath the checkbox so the control and label are top aligned.",
            "src": "/static/22432dd8bc346729a32c9117acf9e16d/a5df1/checkbox-usage-11-do.png",
            "srcSet": ["/static/22432dd8bc346729a32c9117acf9e16d/7fc1e/checkbox-usage-11-do.png 288w", "/static/22432dd8bc346729a32c9117acf9e16d/a5df1/checkbox-usage-11-do.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </DoDont>
  <DoDont type="dont" caption="Do not vertically center wrapped text with the checkbox." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABm0lEQVQ4y+2SSU7DMBSG3RZKWzqkQ5zYqe2kbdqSDpSpLBDiDuzYISR2oB4AxIITcAEuwEHYI4EQILHiHJjnkHRArRACdv2lL29Q3vPvKAjN9Wd65s1h/Cnjc+iJjZoPrPErMxOStY3PxK1EX3lTk3Y3C2Sks5qRdgfydlY6vbQU7Zzqv4tW7o41Si+8mVZjj2DGX6wesnuAiKYh2dqNyFIveVt2148I2zyjondKeP+S2u1zKronhG9fUNEZEL51ZTl1KVr6PWtoauHb8MrwGFDhm7smNj103ON9JgxUzJeRXqogvegAHFC1F+SqR1ECRf3buTuT1+XVSkTFAueFuufdYMuqMl3nFjZqHBsmQMrYEIBtYewxbFhB7eyZNKZmBTZGDpVSmjY8gBWLcYxxF3AAF7ABApSBKsCBNSCh3oc46TBs6LoeM00zD3USyAEpIAvEg96yWgJEgrgQzk8sDQuIS0ATKAErgAd0ApfKWR8wppmZ6jA4afG7/y50ND43c+m0oa/MXDLD4bCG74kIIYhS6scwV1L5XP+jD+rbZAoWnhDnAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Do not vertically center wrapped text with the checkbox.",
            "title": "Do not vertically center wrapped text with the checkbox.",
            "src": "/static/5b39bbaa02b39aecb344de76d1fcd1a2/a5df1/checkbox-usage-11-don't.png",
            "srcSet": ["/static/5b39bbaa02b39aecb344de76d1fcd1a2/7fc1e/checkbox-usage-11-don't.png 288w", "/static/5b39bbaa02b39aecb344de76d1fcd1a2/a5df1/checkbox-usage-11-don't.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </DoDont>
    </DoDontRow>
    <h3>{`Further guidance`}</h3>
    <p>{`For further content guidance, see Carbon’s `}<a parentName="p" {...{
        "href": "notion://www.notion.so/guidelines/content/general"
      }}>{`content guidelines`}</a>{`.`}</p>
    <h2>{`Behaviors`}</h2>
    <h3>{`States`}</h3>
    <p>{`The checkbox input allows for a series of states: `}<strong parentName="p">{`unselected`}</strong>{`, `}<strong parentName="p">{`selected`}</strong>{`, and `}<strong parentName="p">{`indeterminate`}</strong>{`. The default view of a set of checkboxes is having no option selected.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQ4y7VUQQrEIBDz/8/TZ6h4UfCgzpKCpYiOI+0GQqWWkBBSRQu01rbnGRQnhmetdfp+KYjLGYFSCoUQyHtP1lrKOd+CKyrOfncIYXAXl3U4ut05ux1KPoJLUCS4i4yoJ2BLSSmRMYacc1c5ktgih52vHI6F/KUUSTGKPgZbSoyRtNZXKVgKFtOneOTwuVmUMUbm9qwkf5uTux8Bd6Z0/I36ggAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Unselected, selected and indeterminate states of checkbox.",
            "title": "Unselected, selected and indeterminate states of checkbox.",
            "src": "/static/19d93c9d0b6b73e467f082060e781aba/3cbba/checkbox-usage-7.png",
            "srcSet": ["/static/19d93c9d0b6b73e467f082060e781aba/7fc1e/checkbox-usage-7.png 288w", "/static/19d93c9d0b6b73e467f082060e781aba/a5df1/checkbox-usage-7.png 576w", "/static/19d93c9d0b6b73e467f082060e781aba/3cbba/checkbox-usage-7.png 1152w", "/static/19d93c9d0b6b73e467f082060e781aba/92c65/checkbox-usage-7.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <p>{`Use the indeterminate state when the checkbox contains a sublist of selections, some of which are selected, and some unselected. In addition to unselected, selected, and indeterminate states, checkboxes also have states for focus and disabled.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABsElEQVQoz42SzU7CQBDHd1tpVwhKEBCiIHry68CFcDHEEwcfQXwBXsDEk29ATHwMbl4MiYeGIB8XBUQhhXZLiyeOPADObroNHDBM8s9Md3/970y3SD0rIRb+wisKZ0ooQfgjisViiFLKa8uyZJNShdX52zI+zhZxAOr9xCHnBO8FyT2h5Thws23bnuHv1FHQmlgxW+owDh3GoUMioG636xlq7x8qq4+uH0+Ps3cZ6HAbOowCt7tiWnx44Tl48xaK5Mv+nILwYrFA1WoVmabJ92B0+bM35IbJwvNe8uo+eokQTp2cK+l0eovxmqaxg9FGAaA0dWzfRjCcrk4mltr7MchQNwg1TZVSS2XrIMIyGAYg7zj2ROl966T7NYR1Ux2Px8QwDAL7glfZ6RhGw7PZDDuOgwHiGo1GfJ2NAaCPvTQYDNB8PuefRNd1vs9Y2Gccz16n8A1wpVJZN7JM3d+mVqtJwMprR242mzw3Go0gKAKKgsKgGFsTlwKj8Utpt9sp0EW9Xg+5LOOIu8eNhCETBklCrVYLC0PRYb/fx51ORwJDaYn1PFaL9bcsg5T/GOHxBy1tEtEGMD4lAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Focus and disabled states of checkbox.",
            "title": "Focus and disabled states of checkbox.",
            "src": "/static/80d493b8d4d75b661db364521dc419e0/3cbba/checkbox-usage-8.png",
            "srcSet": ["/static/80d493b8d4d75b661db364521dc419e0/7fc1e/checkbox-usage-8.png 288w", "/static/80d493b8d4d75b661db364521dc419e0/a5df1/checkbox-usage-8.png 576w", "/static/80d493b8d4d75b661db364521dc419e0/3cbba/checkbox-usage-8.png 1152w", "/static/80d493b8d4d75b661db364521dc419e0/92c65/checkbox-usage-8.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Interactions`}</h3>
    <h4>{`Mouse`}</h4>
    <p>{`Users can trigger an item by clicking the checkbox input directly or by clicking the checkbox label. Having both regions interactive creates a more accessible click target.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.41447368421052%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABJ0lEQVQoz2NgwAK2Hb0Hpvececawcvs5JhBbXkGJQUxMHIjFwHIwmmiw69RjnHIkG7YV4UJxoAu9gEw+BQUlUaALBYGGMeM19MGDBxh434kbYLmNB27wAA1UBTKZdPUM2RQUFFicnZ0Z/v//z3DkyBGseqkPgKayo+P79++D6bt373Fcu3GH8/adexy37tznuA3EQDkOZDXoGGQgIzZ85/YtxrcfPjOiO+DNo8uM9+4/BKq5j1UfQR/MX3uE4/Kz//x3Pvznv/byP9+Rm78ZCXkZA5ubm4MCHqxx8cbj3luP3O3ddPBWB5Bu2HzotghIfPsxsAuJixRQkrj4+D+YvXzraaba9hksqTmVLGX1fSzd01eCxftmriE9wv79/49VfNqibTj1AACRM+eaeM8oNAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Click targets for checkbox.",
            "title": "Click targets for checkbox.",
            "src": "/static/ea1ff87f6bcf38910a11025364a0b672/3cbba/checkbox-usage-9.png",
            "srcSet": ["/static/ea1ff87f6bcf38910a11025364a0b672/7fc1e/checkbox-usage-9.png 288w", "/static/ea1ff87f6bcf38910a11025364a0b672/a5df1/checkbox-usage-9.png 576w", "/static/ea1ff87f6bcf38910a11025364a0b672/3cbba/checkbox-usage-9.png 1152w", "/static/ea1ff87f6bcf38910a11025364a0b672/92c65/checkbox-usage-9.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h4>{`Keyboard`}</h4>
    <p>{`Users can trigger a state change by pressing `}<inlineCode parentName="p">{`Space`}</inlineCode>{` while the checkbox input has focus. For additional keyboard interactions, see the `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/checkbox/accessibility"
      }}>{`accessibility tab`}</a>{`.`}</p>
    <p>{`Users can navigate between checkbox inputs by pressing `}<inlineCode parentName="p">{`Tab`}</inlineCode>{` or `}<inlineCode parentName="p">{`Shift-Tab`}</inlineCode>{`.`}</p>
    <h4>{`Screen readers`}</h4>
    <p>{`VoiceOver: Users can trigger a state change by pressing `}<inlineCode parentName="p">{`Control-Option-Space`}</inlineCode>{` or `}<inlineCode parentName="p">{`Space`}</inlineCode>{` while the checkbox input has screen reader focus.`}</p>
    <p>{`JAWS: Users can trigger a state change by pressing `}<inlineCode parentName="p">{`Space`}</inlineCode>{` while the checkbox input has screen reader focus.`}</p>
    <p>{`NVDA: Users can trigger a state change by pressing `}<inlineCode parentName="p">{`Space`}</inlineCode>{` while the checkbox input has screen reader focus.`}</p>
    <p>{`For additional information, see `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/checkbox/accessibility#ios-screen-reader-tests"
      }}>{`screen reader tests`}</a>{`.`}</p>
    <h2>{`Related`}</h2>
    <h4>{`Checkbox versus radio button`}</h4>
    <p>{`Radio buttons represent a group of `}<em parentName="p">{`mutually exclusive`}</em>{` choices, while checkboxes allow users to select one or more checkboxes from a group. In use cases where only one selection of a group is allowed, use the radio button component instead of the checkbox.`}</p>
    <h4>{`Checkbox versus toggle switch`}</h4>
    <p>{`Toggle switches are preferred when the resulting action will be instantaneously applied, without the need for further confirmation. By comparison, checkboxes represent one input in a larger flow which usually requires a final confirmation step.`}</p>
    <h4>{`Tables`}</h4>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com/components/data-table/usage#multiselect-batch-action"
      }}>{`data table component`}</a>{` for guidance on how to use checkboxes within a table.`}</p>
    <h2>{`References`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/data-table/code"
        }}>{`Data table`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/form/code"
        }}>{`Form`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/radio-button/code"
        }}>{`Radio button`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/toggle/code"
        }}>{`Toggle`}</a></li>
    </ul>
    <h2>{`Feedback`}</h2>
    <p>{`Help us improve this pattern by providing feedback, asking questions, and leaving any other comments on `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/new?assignees=&labels=feedback&template=feedback.md"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      